"use client";

import type { ReactNode } from "react";

import { cn } from "../../utils/cn.util";
import { Accordion } from "../accordion";
import { ArrowPlainRightIcon } from "../icons";
import { useLayoutContext } from "./context";

export type LayoutSidebarBodyCategoryProps = {
  name?: string;
  children: ReactNode;
  className?: string;
  isExpanded?: boolean;
  isExpandable?: boolean;
};

const SidebarBodyCategory = ({
  children,
  className,
  name,
  isExpanded = true,
  isExpandable = false,
}: LayoutSidebarBodyCategoryProps) => {
  const { openSidebar } = useLayoutContext();

  return (
    <Accordion.Root type="single" collapsible={isExpandable} className="w-full" defaultValue={isExpanded ? "key" : ""}>
      <Accordion.Item value="key" className="flex flex-col">
        {(name || isExpandable) && (
          <Accordion.Trigger
            className={cn(
              "mb-4 flex h-4 cursor-auto gap-1 truncate text-neutral-50 opacity-100 transition-[margin,opacity] duration-200 ease-in-out [&[data-state=open]>svg]:rotate-90",
              isExpandable && "cursor-pointer rounded-lg hover:text-neutral-10",
              !openSidebar && "pointer-events-none opacity-0",
              className
            )}
            onClick={e => e.stopPropagation()}
          >
            <span className={cn("w-full shrink-0 truncate text-left text-xs font-bold")}>{name}</span>
            {isExpandable && <ArrowPlainRightIcon className="size-4 text-neutral-70 transition-all" />}
          </Accordion.Trigger>
        )}
        <Accordion.Content className="flex flex-col gap-2">{children}</Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};

export default SidebarBodyCategory;
